import Box from '@zenbusiness/zui/Box';
import DialogActions from '@zenbusiness/zui/DialogActions';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ConfirmationStack = superstyled({
  tag: Stack,
  name: 'ChangeBillingIntervalAnnualConfirmation',
  slot: 'ConfirmationStack',
  styles: ({ theme }) => ({
    textAlign: 'center',
    paddingBlock: theme.spacing(2),
  }),
});

export const ConfirmationImage = superstyled({
  tag: Box,
  name: 'ChangeBillingIntervalAnnualConfirmation',
  slot: 'ConfirmationImage',
  styles: ({ theme }) => ({
    width: 256,
    maxWidth: '100%',
    marginBottom: theme.spacing(3),
  }),
});

export const ConfirmationTitle = superstyled({
  tag: Text,
  name: 'ChangeBillingIntervalAnnualConfirmation',
  slot: 'ConfirmationTitle',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(1),
  }),
});

export const ModalActions = superstyled({
  tag: DialogActions,
  name: 'ChangeBillingIntervalAnnualConfirmation',
  slot: 'ModalActions',
  styles: ({ theme }) => ({
    justifyContent: 'flex-end',
    paddingInline: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }),
});
